export const VILLAGE_ACTIVE_STATUS = 'active'
export const VILLAGE_DRAFT_STATUS = 'draft'
export const VILLAGE_ARCHIVE_STATUS = 'archive'
